<template>
    <div>
  
      <div class="flexc-cen-x fixed">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
         <el-breadcrumb-item>打卡</el-breadcrumb-item>
        </el-breadcrumb>
        <el-select  v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
            <el-option
                v-for="item in DianList"
                :key="item.ID"
                :label="item.StoresName"
                :value="item.ID"
              >
            </el-option>
        </el-select>
      </div>
 
      <div class="csss">
        <el-form :inline="true" :model="formInline"  style="display:flex;flex-wrap:wrap;padding-top:30px">
            <el-form-item  >
                <el-select v-model="stype"  size="mini" >
                                    <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                </el-select>
             </el-form-item>
          
          <el-form-item label="时间:">
              <el-date-picker
                v-model="tdate"
                :disabled="stype !='4'"
                type="date"
                placeholder="选择日期"
                size="mini"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                style="width:170px"
                >
              </el-date-picker>
                 至
              <el-date-picker
                v-model="mdate"
                :disabled="stype !='4'"
                type="date"
                placeholder="选择日期"
                size="mini"
                style="width:170px"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                >
              </el-date-picker>
          </el-form-item>
          <el-form-item label="搜索：">
            <el-input size="mini" placeholder="请输入姓名/手机号"  style="width:150px" v-model="selectMembersName"  auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-button size="mini" type="primary" icon="el-icon-plus" v-if="q1" @click="addDKClick()">添加打卡</el-button>
        <el-button size="mini" type="danger"  @click="showDKClick()">打卡码</el-button>
      </div>
      <el-table :data="tableData" highlight-current-row v-loading="loading" size="mini"   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
            <el-table-column label="打卡时间" prop="DKTime">
                            </el-table-column>
                            <el-table-column label="学员" prop="sendType">
                                <template slot-scope="scope" class="flexB">
                                    <span >{{scope.row.Name}}({{scope.row.Phone}})</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="子账号" prop="sendType">
                                <template slot-scope="scope" class="flexB">
                                    <span v-if="scope.row.MembersSubID>0" >{{scope.row.SubName}}({{scope.row.SubPhone}})</span>
                                </template>
                            </el-table-column>
                             <el-table-column label="会员卡"  prop="CardName" >
                                  <template slot-scope="scope">
                                   <span>{{scope.row.CardName}}</span>
                                </template>
                             </el-table-column>
                              <el-table-column label="消耗课时"  prop="vipvalue"  >
                             </el-table-column>

                            <el-table-column label="操作时间" prop="addTime"></el-table-column>
          <el-table-column align="center" label="操作" width="380" >
            <template slot-scope="scope">
              <el-button  size="mini" type="primary" v-if="q2" @click="todel(scope.row)">撤销</el-button>
 
            </template>
          </el-table-column>
      </el-table>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
 
        
 

        <el-dialog
            title="提示"
            :visible.sync="dialogdelVisible"
            width="360px"
            center
        >
       <span slot="title">
        <p>打卡码</p>
      </span>
      <div class="flexC">
                    <el-image
                             style="width: 200px; height: 200px"
                            :src="xcxdkPhth"
                          ></el-image>         
     </div>  
    </el-dialog>
          
     <el-drawer
            class="normalDrawer"
            title="添加打卡记录"
            direction="ltr"
            size="60%"
            :visible.sync="showDrawerWD"
            :wrapperClosable="false"
            >
            <div class="drawerForm">
                <el-form  label-width="150px" label-position="right">
                 
                    <el-form-item label="打卡时间：" prop="addTime">
                         <el-date-picker
                            v-model="DKTime"  
                            style="width:180px;"
                            align="right"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择打卡时间">
                        </el-date-picker>
                    </el-form-item>
                     <el-form-item label="选定会员：" prop="NoticeMember">
                        {{MemberName}}
                         <span @click="addClassMemberClick()"  style="color: #409EFF;cursor:pointer" >选择会员</span>

                        <!-- <el-select v-model="MemberName" filterable @change="handleSearchMemberName"  placeholder="请搜索会员姓名">
                            <el-option v-for="item in memberList" :key="item.index" :label="item.Name" :value="item">
                            </el-option>
                        </el-select> -->
                    </el-form-item>
                    <el-form-item label="选择子账号:" v-if="subList.length>0" clearable>
              <el-select v-model="MembersSubID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in subList"
                  :key="item.ID"
                  :label="item.Name"
                  :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
                     <el-form-item label="选择会员卡：" v-if="MembersID>0 &&MembersvipList.length==0"  >
                        <label>无可用会员卡</label>
                    </el-form-item>
                    <el-form-item label="选择会员卡："  v-if="MembersID>0 &&MembersvipList.length>0"  >
                        <el-select v-model="CardName" clearable  @change="changeCardID1"  placeholder="请选择会员卡">
                            <el-option v-for="item in MembersvipList" :key="item.index" :label="item.CardName"  :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="剩余次数：" v-if="showKynumber"  prop="CardIDbx">
                        <label>{{SYCardNumber}}次</label>
                    </el-form-item> 
                    <el-form-item label="剩余金额："v-if="showAmount"  prop="CardIDbx">
                        <label>{{SYAmount}}元</label>
                    </el-form-item>
                    
                    <el-form-item label="有效期：" v-if="showbx"  prop="CardIDbx">
                        <label>{{OverdueTime}}</label>
                    </el-form-item>
                    <el-form-item label="消耗次数："  v-if="showKynumber" prop="ConsumptionOfClass" >
                        <el-input v-model="ConsumptionOfClass" placeholder="消耗次数" style="width:100px;"></el-input> 次
                    </el-form-item> 
                    <el-form-item label="消耗金额："  v-if="showAmount" prop="singlePrice" >
                        <el-input v-model="singlePrice" placeholder="消耗金额" style="width:100px;"></el-input> 元
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="medium" @click="submitFormNotestateClass()">确认提交</el-button>
                        <el-button @click="showDrawerWD = false">取消</el-button>
                    </el-form-item>            
                </el-form>
            </div>
        </el-drawer>
  
        <el-dialog :title="'选择'+WZHYName" :visible.sync="vipShow"  >
      <el-form :inline="true" :model="formInline" class="user-search" style="margin-top:-20px">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="selectName" placeholder="输入姓名、手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search1">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table  :data="vipList" highlight-current-row  max-height="400" style="width: 100%;">
          <el-table-column  prop="Name" label="姓名" align="center" >
            <template slot-scope="scope">
              <div class="flex-xy">
                <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:50px;height:50px;border-radius:100%" alt="">
                <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:50px;height:50px;border-radius:100%" alt="">
                <div style="margin-top:5px;font-size:15px">{{scope.row.Name}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="Phone" label="手机号"  align="center">
          </el-table-column>
          <el-table-column v-if="isCard==0"  prop="czAmount" label="储蓄金额(元)"  align="center">
          </el-table-column>
          <el-table-column v-if="isCard==0" prop="syNumber" label="次卡次数"  align="center">
          </el-table-column>

          

        <el-table-column align="center" label="操作" fixed="right" >
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDetail(scope.row)">选择</el-button>
        
          </template>
        </el-table-column>
      </el-table>

      <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
    </el-dialog>
    </div>
  </template>
  
  <script>
  import { deptList, deptSave, deptDelete } from '../../api/userMG'
  import CropperImage from "../../components/CropperImage";
  import { } from "@/api/getData";
  import Pagination from '../../components/Pagination'
  import { baseUrl } from "../../config/env.js";
  import * as imageConversion from 'image-conversion'
  export default {
    data() {
      return {
        formValidate: {
          mainImage: "",
        },
        tdate:'',
         showRightDrawer3:false,
        mdate:'',
        code:'',
        row:'',
        URL: baseUrl + "upload_images.aspx",
        selectMembersName:"",
        otherShow:false,
        vipShow:false,
        personList:[],
        Note:'',
        Site:'',
        selectstate:'0',
        cardList:[],
        activeName: 'first',
        value:true,
        direction: "ltr",
        projectList:[],
        MembersvipList:[],
        passShow:false,
        isCard:localStorage.getItem("isCard"),
        xcxdkPhth:localStorage.getItem("xcxdkPhth"),
        input:'',
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        chongShow:false,
        SelectStoresID:localStorage.getItem("StoresID"),
        IsCD:localStorage.getItem("IsCD"),
        iskczk:localStorage.getItem("iskczk"),
        issfxk:localStorage.getItem("issfxk"),
        title: '添加',
        tableData:[],
        isUser:'',
        stype:'0',
        cardType:'',
        Pwd:'',
        objID:'',
        site:'',
        mainList:[],
        DianList:[],
        cheShow:false,
           WZYGName:'',
      WZHYName:'',
      WZXMName:'',
      WZPBName:'',
        hexiaoShow:false,
        LoginID:-1,
        stateList:[
          {
            value:3,
            label:'未到'
  
          },
        
           {
            value:5,
            label:'请假'
  
          },
        ],
    
      //   SelectStoresID:1,
        editForm: {
          LoginName:"",
          Phone:"",
          Name:"",
          pwd:"",
          money:"",
          ShopName:"",
          token: localStorage.getItem('token')
        },
        money:1.00,
        // rules表单验证
  personShow:false,     
        rules: {
          LoginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
            Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
            Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
            pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
            money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
            ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
        },
        formInline: {
          page: 1,
          limit: 10,
          varLable: '',
          varName: '',
          token: localStorage.getItem('logintoken')
        },
        formInline1: {
          page: 1,
          limit: 10,
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        isCode:0,
        number:1,
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }, pageparm1: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        info:'',
        isxk:0,
        state:'',
        Limits:[],
        fileList:[],
        q1:false,
        q2:false,
        q3:false,
        q4:false,
        q5:false,
        q6:false,
        typeName:'',
        GoodsList:[],
        WZCDName:'',
        numberShow:false,
        dialogdelVisible:false,
        ConsumptionOfClass:"",
                singlePrice:"",
                showKynumber:false,
                showAmount:false,
                showbx:false,
                showDrawerWD:false,
                vipID:"",
                 SYCardNumber:"",
                SYAmount:"",
                OverdueTime:"",
                CardType:"",
                editstate:"",
                PreAboutID:"", 
                PreAboutisZF:"", 
                cxNote:"",
                MembersID:"",
                 CardName:"",
                vipID:"",
                MemberName:"",
                DKTime:"",
                subName:"", 
                MembersSubID:"",
                 subList:[], 
                 vipList:[],
                 selectName:"",
      }
    },
    // 注册组件
    components: {
      Pagination,
       CropperImage,
    }, computed: {
            timeDefault() {
      var date = new Date();
      var s1 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate());
      return s1;
    } },
    /**
     * 数据发生改变
     */
  
    /**
     * 创建完毕
     */
    created() {
      this.WZYGName = localStorage.getItem('WZYGName')
      this.WZHYName = localStorage.getItem('WZHYName')
      this.WZXMName = localStorage.getItem('WZXMName')
      this.WZPBName = localStorage.getItem('WZPBName')
      this.WZCDName = localStorage.getItem('WZCDName')
      
        if(localStorage.getItem('isAdmin') == 1){
            this.q1 = true
            this.q2 = true
            this.q3 = true
            this.q4 = true
            this.q5 = true
            this.q6 = true
        }
    this.Limits = localStorage.getItem('Limits')
        this.Limits = this.Limits.split(',')
        this.Limits.forEach(items => {
            if(items == 192){
              this.q1 = true
            }
            if(items == 193){
              this.q2 = true
            }
            if(items == 24){
              this.q3 = true
            }
            if(items == 25){
              this.q4 = true
            }
            if(items == 26){
              this.q5 = true
            }
            if(items == 43){
              this.q6 = true
            }
            
     })
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
  
  
            if (month < 10) {
            month = '0' + month;
            }
            if (day < 10) {
            day = '0' + day;
            }
            // var nowDate = 
          // this.data.[0] = 
        this.tdate = year + '-' + month + '-' + day;
        var days = 6
        var last = new Date(date.getTime() + (days * 24 * 60 * 60 * 1000))
          year = last.getFullYear();
          month = last.getMonth() + 1;
          day = last.getDate();   
  
        this.mdate = year + '-' + month + '-' + day;
      
        this.getDianList()
        this.getList()
        // this.ge1tList()
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
  
        addClassMemberClick(){
          this.getvipList()
        },
        getvipList(){
      var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline1.page,
          psize:this.formInline1.limit,
          selectName:this.selectName,
      }
      
      
        var that = this
      this.ajax('getListMembersYY.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              
                that.vipList = res.data
                that.pageparm1.total = res.allcount
                that.vipShow=true

          } 

      })
  
},submitFormNotestateClass(){
  if(this.DKTime==''){
                  this.$message({ type: "error", message: '请选择打卡时间'  ,duration:1000});
                    return;
                }
                if(this.MembersID=='' || this.MembersID==0){
                  this.$message({ type: "error", message: '请选择会员'  ,duration:1000});
                    return;
                }

  var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID: this.MembersID,
           Note: this.Note,
           ConsumptionOfClass:this.ConsumptionOfClass,
          singlePrice: this.singlePrice,
           vipID: this.vipID,
           DKTime: this.DKTime,
            MembersSubID: this.MembersSubID,
          }
          var that = this
       this.ajax('addMembersDK.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
                that.showDrawerWD = false;
               that.getList()
            }
      })
},changeCardID1(val){
                this.vipID = val.ID;
                this.CardName = val.CardName; 
                this.SYCardNumber = val.CardNumber;
                this.SYAmount = val.Amount;
                this.OverdueTime= val.OverdueTime;
                this.CardType = val.CardType;
                this.ConsumptionOfClass= ''; 
                this.singlePrice= ''; 

              if(val.CardType  ==1){
                this.showKynumber= true;
                this.showAmount=false;
                this.showbx =false;
                this.ConsumptionOfClass= val.DKvalue; 
                }else if(val.CardType  ==2){
                this.showKynumber= true;
                this.showAmount= false;
                this.showbx =false;
                 this.ConsumptionOfClass= val.DKvalue;
                }else if(val.CardType  ==3){
                this.showKynumber= false;
                this.showAmount=false;
                this.showbx =true;
                }else if(val.CardType  ==4){
 
                this.showKynumber= false;
                this.showAmount= true;                
                this.showbx =false;
                this.singlePrice= val.DKvalue;


                }else if(val.CardType  ==5){
 
                this.showKynumber= false;
                this.showAmount= true;                
                this.showbx =false;
                this.singlePrice= val.DKvalue;
                }

            },
  handleDetail(items){
        this.MemberName = items.Name
       
        this.MembersID = items.ID
      
        this.vipShow = false
        this.pageparm = {
          currentPage: 1,
          pageSize: 10,
          total:0,
        }
        
        this.getListMembersvipDK()

         this.getSubList()
    },search1(){
      this.formInline1 =  {
          page: 1,
          limit:10,
      },
      this.getvipList()
    },
getSubList(){
       var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.MembersID,
          }
          var that = this
       this.ajax('getListMembersSub.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.subList =res.data  
               that.subName = ''
               that.MembersSubID = ''    
            }
      })
      // this.ziShow = true
    }, 
        addDKClick(){
            this.MembersID="";
                 this.MemberName="";
                 this.Note="";
                 this.ConsumptionOfClass="";
                 this.singlePrice="";
                this.vipID="";
                this.CardName ="";
                this.MembersSubID ="";

                
                this.DKTime=this.timeDefault;
                this.showKynumber= false;
                this.showAmount= false;                
                this.showbx =false;
                this.showDrawerWD = true;
        },getListMembersvipDK(){
            var data = { 
           SelectStoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            MembersID:this.MembersID
        }
          var that = this
         this.ajax('getListMembersvipDK.aspx',JSON.stringify(data),"POST",function(res){
  
             if (res.orsuccess == "1") {
                 that.MembersvipList =res.data
                 
              }
  
        })
        },
        showDKClick(){
                this.dialogdelVisible=true;
            },
       getDianList(){
         var data = { 
           SelectStoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID")
        }
          var that = this
         this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){
  
             if (res.orsuccess == "1") {
                 that.DianList =res.data
                 
              }
  
        })
      },
      getList(){
  
        if(this.mdate < this.tdate){
          this.$message({ type: "error", message: "结束时间不得小于开始时间" ,duration:1000});
              return;
        }
  
        var data = { 
           SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            selectMembersName:this.selectMembersName,
            stype:this.stype,
            sTime:this.tdate,
            eTime:this.mdate,
            pages:this.formInline.page,
            psize:this.formInline.limit,
        }
          var that = this
          const loading = this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
         this.ajax('getListMembersDK.aspx',JSON.stringify(data),"POST",function(res){
             if (res.orsuccess == "1") {
          
                that.tableData = res.data
                that.pageparm.total = res.allcount
                that.tdate= res.sTime
                that.mdate= res.eTime
  
              }
              loading.close();

        })
      },
  
      changedian(){
        this.formInline= {
          page: 1,
          limit: 10,
        },
      this.getList()
    },
 
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getList()
      },callFather1(parm) {
        this.formInline1.page = parm.currentPage
        this.formInline1.limit = parm.pageSize
        this.getvipList()
      },
      // 搜索事件
      
      search() {
        this.formInline= {
          page: 1,
          limit: 10,
        },
        this.getList()
        
      },
 
 
  
      todel(items){
        this.$confirm("确定要取消预约吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
              var data = { 
                SelectStoresID:this.SelectStoresID,
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                MembersDKID:items.ID,
                isdel:1
              }
              var that = this
              this.ajax('delMembersDK.aspx',JSON.stringify(data),"POST",function(res){
  
                if (res.orsuccess == "1") {
                    that.$message({
                      type: "success",
                      message: "撤销成功",duration:2000,
                    });
              
                    that.getList()
                
                    //  that.provinceList = res.data
                  }
  
              })
              })
              .catch(() => {
  
              });
  
      },
       
    
    }
  }
  </script>
  <style>
  .csss .el-form-item {
      margin-bottom: 5px;
  }
  
  </style>
  <style scoped>
  .bottomBORD{
    padding-bottom: 30px;
    width:100%;
    border-bottom: 1px solid #e9e9e9;
  }
  .flexC{
    display: flex;
    justify-content: center;
}
  .main{
    position: absolute;
  }
  .content{
      font-size: 12px;
    color: #999;
    line-height: 20px;
  }
  .titleMain{
      font-size: 14px;
      color: #191919;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }
  .offline___NHq4e {
      position: absolute;
      top: -1px;
      right: -1px;
      padding: 0.5px 4px 0.5px 4px;
      /* width: 64px; */
      /* height: 22px; */
      background: rgba(255, 101, 247, 0.04);
      border-radius: 0 8px 0 8px;
      border: 1px solid rgba(187, 14, 255, 0.2);
      font-size: 12px;
      text-align: center;
      line-height: 20px;
      color: #b336fc;
  }
  .box{
    position: relative;
      width: calc((100% - 80px)/4);
      padding: 20px;
      box-sizing: border-box;
      display: inline-block;
      margin-right: 16px;
      margin-bottom: 16px;
      border-radius: 8px;
      border: 1px solid #ececec;
      box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
      height: 130px;
  }
  @media screen and ( max-width: 1400px ) {
    .box{
      cursor: pointer;
      width: calc((100% - 60px)/3);
    }
  }
  .box:hover{
    box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
  }
  .shadow:hover {
      border:1px solid #808080;border-radius:2px
  }
  .shadow {
      border:1px solid #ffffff;border-radius:2px
  }
  
  .xiang{
      padding: 1px 4px  1px 4px;
      background-color: #f7f7f7;
      border:1px solid #bbbbbb;
      border-radius: 3px;
      font-size: 10px;
      color:#bbbbbb;
  }
    
  /* .el-switch__core::after{
   height: 12px !important;
   width :12px !important;
  } */
     
  .title{
      margin-top: 10px;
      height: 30px;
      font-size: 13px;
      font-weight: bolder;
      border-radius: 3px;
      border-left: 5px solid #334157;
  
  }
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/billboard/recordDK.vue